module.exports = __webpack_public_path__ + "img/download-2-2.b1639280.png";